let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("P6QKc")).then(() => parcelRequire('14Ij7'));